import React, { createContext, useContext, ReactNode } from 'react';
import type { Platform } from '../types/platform';

const PlatformContext = createContext<Platform | null>(null);

interface PlatformProviderProps {
  platform: Platform;
  children: ReactNode;
}

export function PlatformProvider({ platform, children }: PlatformProviderProps) {
  return (
    <PlatformContext.Provider value={platform}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform(): Platform {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error('usePlatform must be used within PlatformProvider');
  }
  return context;
}

export function useFileService() {
  return usePlatform().file;
}

export function useStorageService() {
  return usePlatform().storage;
}

export function useDialogService() {
  return usePlatform().dialog;
}

export function useBufferService() {
  return usePlatform().buffer;
}

export function useDownloadService() {
  return usePlatform().download;
}

export function usePlatformCapabilities() {
  return usePlatform().capabilities;
}
